// Shared GraphQL fragments used across many modules. Prefer colocating new
// fragments next to the query or component that uses them (see `fragment.ts`
// files under `app/components/`) instead of adding to this file.
export const responsiveImageFragment = `
  fragment responsiveImageFragment on ResponsiveImage {
    alt
    base64
    height
    sizes
    src
    srcSet
    title
    width
  }
`;

/** 1200×630 rendition used for `og:image` and `twitter:image`. */
export const openGraphImageField = `
  responsiveImage(
    imgixParams: {
      auto: format
      fill: blur
      fit: fill
      h: 630
      q: 45
      w: 1200
    }
  ) { ...responsiveImageFragment }
`;

export const metaTagsFragment = `
  fragment metaTagsFragment on Tag {
    attributes
    content
    tag
  }
`;

export const formInputFragment = `
  fragment formInputFragment on FormInputRecord {
    code
    name
    label
    labelNew {
      value
    }
    inputType
    placeholder
    validationMessages {
      invalidMessage
      lengthMessage
      requiredMessage
    }
  }
`;

export const gaEventFragment = `
  fragment gaEventFragment on GaEventRecord {
    __typename
    eventCategory
    eventAction
    eventLabel
  }
`;

export const targetFragment = `
  fragment targetFragment on TargetRecord {
    anchor
    blogArticle {
      previewUrl
    }
    gaEvent {
      ...gaEventFragment
    }
    io
    link
    route {
      page {
        __typename
      }
      path
      updatedPath
    }
  }
`;

export const linkFragment = `
  fragment linkFragment on LinkRecord {
    __typename
    text
    target {
      ...targetFragment
    }
    icon {
      ...iconFragment
    }
  }
`;

export const iconFragment = `
  fragment iconFragment on IconRecord {
    __typename
    name
    color
    placement
  }
`;

export const buttonFragment = `
fragment buttonFragment on ButtonRecord {
  __typename
  id
  text
  icon {
    ...iconFragment
  }
  target {
    ...targetFragment
  }
  variant
}

${gaEventFragment}
${iconFragment}
`;

export const listWithIconsFragment = `
  fragment listWithIconsFragment on ListWithIconsBlockRecord {
    __typename
    id
    listItems {
      icon {
        ...iconFragment
      }
      text
    }
  }
`;

export const moduleFormatFragment = `
  fragment moduleFormatFragment on ModuleFormatRecord {
    background
    spacingTop
    spacingBottom
  }
`;

export const storyFragment = `
  fragment storyFragment on StoryRecord {
    userName
    userPicture {
      responsiveImage(imgixParams: {fit: crop, q: 45, w: 50, h: 50, auto: format, mask: ellipse}) {
        ...responsiveImageFragment
      }
    }
    userRole,
    company {
      ...companyFragment
    }
    video {
      alt
      video {
        ...videoFragment
      }
    }
  }
`;

export const videoFragment = `
  fragment videoFragment on UploadVideoField {
    blurUpThumb
    duration
    height
    mp4Url
    thumbnailUrl
    width
  }
`;

export const companyFragment = `
  fragment companyFragment on CompanyRecord {
    name
    horizontalBackgroundLogo {
      responsiveImage(imgixParams: {fit: clip, q: 45, w: 126, h: 36, auto: format})  {
        ...responsiveImageFragment
      }
    }
    horizontalTransparentLogo {
      responsiveImage(imgixParams: {fit: clip, q: 45, w: 126, h: 36, auto: format})  {
        ...responsiveImageFragment
      }
    }
    compactBackgroundLogo {
      responsiveImage(imgixParams: {fit: crop, q: 45, w: 36 h: 36, auto: format})  {
        ...responsiveImageFragment
      }
    }
  }
`;
